module.exports = __webpack_public_path__ + "img/dish3.2877a6ed.png";